document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});
$(document).ready(function(){
    customProduct();
})

function customProduct() {
    if($('.product').length){
        var productsCodes = [];
        
        // Projdi všechny produkty a získej kódy
        $('.product').each(function() {
            var sku = $(this).find('span[data-micro="sku"]').text().trim();
            if (sku) {
                productsCodes.push(sku);
            }
            
            var minValue = $(this).find('.p-tools form input[name="amount"]').attr('value')
            var quantity = '<span class="quantity">'+
                            ' <label><input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="'+minValue+'" min="'+minValue+'" max="9999" aria-label="Množství" data-testid="cartAmount"></label>'+
                            '<button class="increase" aria-label="Zvýšit množství" tabindex="0" role="button" data-testid="increase"></button>'+
                            '<button class="decrease" aria-label="Snížit množství" tabindex="0" role="button" data-testid="decrease"></button>'+
                        '</span>'
            $(this).find('.p-code').addClass('loaded')
            if(!$(this).find('a.image .p-code').length){
                $(this).find('a.image').append($(this).find('.p-code'))
            }
            if(!$(this).find('.ratings-wrapper .p-code').length){
                $(this).find('.ratings-wrapper').append($(this).find('.p-code').clone())
            }
           
            if ($(this).find('.image .price-standard').length) {
                $(this).find('.flag.flag-discount').html($(this).find('.flag.flag-discount').html().replace(/^\s*od\s*/i, '').replace(/\s*až\s*/i, '').trim());
                if(!$(this).find('.superPrice').length){
                    $(this).find('.prices').addClass('superPrice').prepend($(this).find('.image .price-standard'));
                }
            }
            
            if($(this).find('.add-to-cart-button').length>0){
                if(!$(this).find('.quantity').length){
                    $(this).find('.add-to-cart-button').before(quantity)
                }
            }
        });
       
        // ========================================
        // NOVÉ API - POUZE 1 DOTAZ PRO VŠECHNY PRODUKTY!
        // ========================================
        
        if (productsCodes.length > 0) {
            
            var apiUrl = "https://php.shopcode.cz/api/kvalitniBoticky/api-related.php";
            
            // Zavolej API s VŠEMI kódy najednou (oddělené čárkou)
            $.ajax({
                url: apiUrl,
                type: "GET",
                data: {
                    codes: productsCodes.join(",")  // TB-PPK-CD-01,30925P,30923V,...
                },
                dataType: "json",
                success: function(response) {
    
                    if (!response.success || !response.result) {
                        console.log("API nevrátilo data");
                        return;
                    }
                    
                    // Zpracuj všechny produkty
                    $.each(response.result, function(index, group) {
                        
                        // Zkontroluj alternativy
                        if (!group.alternatives || group.alternatives.length === 0) {
                            return;
                        }
                        
                        // Seřadíme podle jména A → Z
                        group.alternatives.sort(function(a, b) {
                            var nameA = a.name || '';
                            var nameB = b.name || '';
                            return nameA.localeCompare(nameB);
                        });
                        
                        // Najdeme produkt na výpisu
                        var $productEl = $('.products-block .product').filter(function() {
                            return $(this)
                                .find('a.image span[data-micro="sku"]')
                                .first()
                                .text()
                                .trim() === group.code;
                        });
                        
                        if ($productEl.length) {
                            
                            $productEl.addClass('product-has-friend');
                            
                            var addFriend = '';
                            var totalFriends = group.alternatives.length;
                            
                            var maxVisible = window.innerWidth >= 1440 ? 4 : 3;
                            
                            if (totalFriends === maxVisible + 1) {
                                maxVisible = totalFriends;
                            }
                            
                            // Vykreslíme maxVisible barevných variant
                            for (var i = 0; i < Math.min(totalFriends, maxVisible); i++) {
                                var item = group.alternatives[i];
                                
                                // Z API máme: url, image, name
                                var itemUrl = item.url || '#'; 
                                var itemImage = item.image || '';
                                var itemName = item.name || '';
                                
                                // Doplň CDN domain pro obrázek (pokud je relativní)
                                if (itemImage && itemImage.charAt(0) === '/') {
                                    itemImage = '' + itemImage;
                                }
                                
                                addFriend += `
                                    <li>
                                        <a href="${itemUrl}">
                                            <img src="${itemImage}" alt="${itemName}" />
                                        </a>
                                    </li>
                                `;
                            }
                            
                            // Pokud jich je více → zobraz "+X"
                            if (totalFriends > maxVisible) {
                                var hiddenCount = totalFriends - maxVisible;
                                addFriend += `<li class="more-friends">+ ${hiddenCount}</li>`;
                            }
                            
                            // Vložení do DOMu
                            if (!$productEl.find('.productFriends').length) {
                                $productEl.find('.image').append(`
                                    <div class="productFriends">
                                        <ul>${addFriend}</ul>
                                    </div>
                                `);
                            }
                        }
                    });
                    
                    console.log("✓ Načteno " + response.result.length + " produktů s alternativami");
                    
                },
                error: function(xhr, status, error) {
                    console.error("Chyba při volání API:", error);
                }
            });
        }
    }
}